import { ws } from "../../../utils/common";

export const getListAssociationsWS = async ({ favourite, volunteer }) => {
  console.log(favourite);
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "association/info/",
    { favourite, volunteer },
    null,
    true
  );

  if (res.error) {
    throw res.data.title;
  } else {
    return res.data;
  }
};
